import type {
  LeadFlowSectionTakeover,
  LeadFlowStepDefinition,
  LeadFlowStepTheme,
} from "../types";

import { resolveLegacyTheme } from "~www/lib/page-builder/resolve-legacy-theme";

type ResolveLeadFlowStepThemeInput = {
  isInContentSlot: boolean;
  isOnSurface: boolean;
  isTakingOverSection: boolean;
  sectionTakeover: LeadFlowSectionTakeover | undefined;
  theme: LeadFlowStepDefinition["theme"];
};

/**
 * The authored theme, or for a step authored before steps had one, the look
 * its placement gave it: Calm on a dialog, in the section takeover, and
 * on a first step that already sits beside the takeover surface; the
 * section's own theme and media elsewhere.
 */
function resolveStepTheme({
  isInContentSlot,
  isOnSurface,
  isTakingOverSection,
  sectionTakeover,
  theme,
}: ResolveLeadFlowStepThemeInput): LeadFlowStepTheme {
  const authoredTheme = resolveLegacyTheme(theme);
  if (authoredTheme) {
    return authoredTheme;
  }

  if (
    isOnSurface ||
    isTakingOverSection ||
    (isInContentSlot && sectionTakeover === "all-steps")
  ) {
    return "calm";
  }

  return "inherit";
}

export { resolveStepTheme };
